// 🚨 AUTO-GENERADO desde InvoiceDataType.ts - No editar manualmente

export const InvoiceFormDataKeys = [
  "id",
  "numero",
  "sequence",
  "invoice_key",
  "tipo",
  "nombre_factura",
  "tel1",
  "tel2",
  "email",
  "direccion",
  "clientActivitycode",
  "fecha",
  "cerrada",
  "porcenta_descuento",
  "subtotal",
  "discountCode",
  "descuento",
  "impuestos",
  "impuestos_servicio",
  "total",
  "fair_id",
  "anulada",
  "tipo_identificacion",
  "identificacion",
  "pagada",
  "status",
  "saleCondition",
  "es_apartado",
  "exenta",
  "with_user_info",
  "exchange_rate",
  "einvoice_status",
  "edocument_status_payload",
  "einvoice_kind",
  "document_comments",
  "customfields",
  "info_references",
  "otros_cargos",
  "plazo",
  "interest_exempt",
  "activitycode",
  "tax_regime",
  "selected_logo",
  "descuento_con_nota",
  "bultos",
  "shipping_carrier",
  "clientId",
  "client",
  "currencyId",
  "currency",
  "recibeId",
  "recibe",
  "salemanId",
  "saleman",
  "invoiceProducts",
  "invoicePayments",
  "creditnotes",
  "debitnotes",
  "interestEntries",
  "apliedCreditnote",
  "apliedDebitnote",
  "user",
  "razon_social",
  "reference_number"
] as const;
